// URL hash sharing - encodes/decodes a track to a compact URL fragment

function compactPoints(points) {
    // Reduce precision to ~5 decimals (~1.1m) to keep URLs small
    return points.map((p) => {
        const arr = [
            Number(p.lat.toFixed(5)),
            Number(p.lng.toFixed(5)),
        ];
        if (typeof p.ele === "number") arr.push(Math.round(p.ele));
        return arr;
    });
}

function expandPoints(arr) {
    return (arr || []).map((a) => ({
        lat: a[0],
        lng: a[1],
        ele: a[2],
    }));
}

function compactPois(pois) {
    return (pois || []).map((p) => {
        const arr = [
            Number(p.lat.toFixed(5)),
            Number(p.lng.toFixed(5)),
            p.name || "",
            p.desc || "",
        ];
        return arr;
    });
}
function expandPois(arr) {
    return (arr || []).map((a) => ({
        lat: a[0],
        lng: a[1],
        name: a[2] || "POI",
        desc: a[3] || "",
    }));
}

export function encodeTrack(track) {
    const payload = {
        n: track.name || "",
        p: compactPoints(track.points || []),
        i: compactPois(track.pois || []),
    };
    const json = JSON.stringify(payload);
    // base64-url
    const b64 = btoa(unescape(encodeURIComponent(json)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    return b64;
}

export function decodeTrack(b64) {
    try {
        const padded = b64.replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(escape(atob(padded)));
        const data = JSON.parse(json);
        return {
            name: data.n || "Ruta compartida",
            points: expandPoints(data.p),
            pois: expandPois(data.i),
        };
    } catch (e) {
        return null;
    }
}

export function buildShareUrl(track) {
    const enc = encodeTrack(track);
    const base = `${window.location.origin}${window.location.pathname}`;
    return `${base}#r=${enc}`;
}

export function readHashTrack() {
    const h = window.location.hash;
    if (!h.startsWith("#r=")) return null;
    return decodeTrack(h.slice(3));
}
